import { TRACKING_UTILS } from "utils";
import reduxstore from "store/store";
import C from "Constants";

const isPixelEnabled = (pixelName) => {
  let { brandInfo } = reduxstore.getState()?.brandStorageReducer;
  let isActive = !!brandInfo?.activeIntegrations?.find(
    (integration) =>
      integration?.name === pixelName && integration?.isActive === true
  );

  return isActive;
};

const isFaceBookPixelEnabled = () => isPixelEnabled(C.FACEBOOK_PIXEL);

const isTiktokPixelEnabled = () => isPixelEnabled(C.TIKTOK_PIXEL);

// The two providers disagree on the type of `value`.
//
// Facebook has always been sent a string and reports correctly, so its payload
// is left exactly as it was rather than disturbing a working integration.
//
// TikTok discards a non-numeric value. The event still records, but with no
// revenue attached -- the pixel shows activity while Optimization Event
// continues to report no usable data. Send it a number.
const facebookMoney = (cartTotal) => ({
  value: cartTotal?.toString(),
  currency: C.AED,
});

const tiktokMoney = (cartTotal) => ({
  value: Number(cartTotal) || 0,
  currency: C.AED,
});

export const AddToCart = (item) => {
  if (isFaceBookPixelEnabled()) {
    // Left exactly as it was. Facebook's AddToCart has always been sent empty
    // and reports correctly; changing its payload would alter live reporting.
    TRACKING_UTILS.triggerFacebookEvent(
      "AddToCart",
      {},
      { isCustomEvent: false }
    );
  }

  if (isTiktokPixelEnabled()) {
    // TikTok was previously sent this event with no payload at all. The event
    // never appeared in Pixel Helper and carried nothing to optimise on, which
    // is the whole point of installing the pixel. Send what the basket knows.
    const quantity = Number(item?.quantity) || 1;
    const unitPrice = Number(item?.price) || 0;
    const payload = { value: unitPrice * quantity, currency: C.AED, quantity };
    if (item?.itemId) {
      payload.content_id = String(item.itemId);
      payload.content_type = "product";
    }
    TRACKING_UTILS.triggerTiktokEvent("AddToCart", payload);
  }
};

export const initiateCheckout = (cartTotal) => {
  if (isFaceBookPixelEnabled()) {
    TRACKING_UTILS.triggerFacebookEvent(
      "InitiateCheckout",
      facebookMoney(cartTotal),
      { isCustomEvent: false }
    );
  }

  if (isTiktokPixelEnabled()) {
    TRACKING_UTILS.triggerTiktokEvent(
      "InitiateCheckout",
      tiktokMoney(cartTotal)
    );
  }
};

export const purchase = (cartTotal) => {
  if (isFaceBookPixelEnabled()) {
    TRACKING_UTILS.triggerFacebookEvent("Purchase", facebookMoney(cartTotal), {
      isCustomEvent: false,
    });
  }

  if (isTiktokPixelEnabled()) {
    // TikTok's completed-order event is CompletePayment, not Purchase.
    TRACKING_UTILS.triggerTiktokEvent(
      "CompletePayment",
      tiktokMoney(cartTotal)
    );
  }
};
